module.exports = __webpack_public_path__ + "img/api-monitor.b48d91a3.svg";